import { BaseEntity } from './BaseEntity';

export class BaseRequestModel<T> {  
    public data: T;

  // Constructor
    constructor(data:T) {
        this.data = data;        
    }
}

export class BaseRequestAPIModel<T> {  
    public body: T;
    public updatedRow: T;
    public apiURLModel: RequestAPIUrlModel;
        
  // Constructor
    constructor(body:T, updatedRow:T, apiURLModel: RequestAPIUrlModel) {
        this.body = body;
        this.updatedRow = updatedRow;
        this.apiURLModel = apiURLModel;
    }
}

export class RequestAPIUrlModel {
    public url : string;
    public additionalUrl : string
}

export interface BaseRequestComponentModel {
  pageFunction: {};
}

export interface RequestMstWarehouseComponentModel extends BaseRequestComponentModel {    
  locationList: [];
}

export interface RequestMstUserComponentModel extends BaseRequestComponentModel {
  buList: [];
  gbpList: [];
  roleList: [];
}

export interface RequestMstLayoutComponentModel extends BaseRequestComponentModel {
  buList: [];
  gbpList: [];
  rackTypeList: [];
  rackCategoryList: [];
}

export interface RequestReportMappingLayoutComponentModel extends BaseRequestComponentModel {
  locationList: [];  
  rackTypeList: [];
}